import { useContextState } from "../../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {
        indexContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        title: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        containerButon: {
            display: 'flex',
            justifyContent: 'end'
        },
        expandButton:{
            '& .MuiSvgIcon-root': {
                fontSize: '18px',
            },
            '& .MuiButtonBase-root': {
                fontSize: '18px',
                padding:'0px'
            },
        },
        buton: {
            textDecoration: 'underline',
            color: colors.color10,
            fontSize: '12px',
            '& .MuiSvgIcon-root': {
                fontSize: '14px'
            },
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        grid: {
            paddingLeft:'4px', 
            paddingRight: '4px'
        }
    }
}

export { useStyles }